import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiService } from '@/utils/api';

interface RegisterData {
  email: string;
  password: string;
}

const Register: React.FC = () => {
  const [register, setRegister] = useState<RegisterData>({
    email: '',
    password: ''
  });
  const [registerResult, setRegisterResult] = useState<string>('');
  const [token, setToken] = useState<string | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    refreshToken();
  }, []);

  const refreshToken = () => {
    const storedToken = localStorage.getItem('user-token');
    setToken(storedToken);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setRegister(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const doRegister = async (e: React.FormEvent) => {
    e.preventDefault();
    
    try {
      const response = await apiService.register(register);
      console.log(response);
      setRegisterResult('Ok');
      // Optionally redirect to login or dashboard
      navigate('/login');
    } catch (error: any) {
      console.log('Registration Failed!');
      console.log(error.message);
      setRegisterResult(error.message || 'Registration failed');
    }
  };

  if (token === 'false' || !token) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <h1 className="text-center text-2xl font-bold text-red-600 animate-pulse">
          Get the hell outta here!!!
        </h1>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h1 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Register new user
          </h1>
        </div>
        <form className="mt-8 space-y-6" onSubmit={doRegister}>
          <div className="space-y-4">
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                Email:
              </label>
              <input
                id="email"
                name="email"
                type="text"
                required
                className="mt-1 appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                placeholder="Enter email"
                value={register.email}
                onChange={handleInputChange}
              />
            </div>
            <div>
              <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                Password:
              </label>
              <input
                id="password"
                name="password"
                type="password"
                required
                className="mt-1 appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                placeholder="Enter password"
                value={register.password}
                onChange={handleInputChange}
              />
            </div>
          </div>
          <div>
            <button
              type="submit"
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Register
            </button>
          </div>
        </form>
        {registerResult && (
          <div className="mt-4 p-4 rounded-md bg-red-50 border border-red-200">
            <p className={`text-sm ${registerResult === 'Ok' ? 'text-green-600' : 'text-red-600'}`}>
              {registerResult}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Register;
